import { render, staticRenderFns } from "./copy6.vue?vue&type=template&id=9c0c9d90&scoped=true"
import script from "./copy6.vue?vue&type=script&lang=js"
export * from "./copy6.vue?vue&type=script&lang=js"
import style0 from "./copy6.vue?vue&type=style&index=0&id=9c0c9d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0c9d90",
  null
  
)

export default component.exports